interface ConfidenceGaugeProps {
  confidence: number;
  accent: "gold" | "sell" | "turquoise";
  size?: number;
}
const ACCENT_HEX: Record<ConfidenceGaugeProps["accent"], string> = {
  gold: "#d9b34a",
  sell: "#c1616a",
  turquoise: "#45c9bd",
};
export default function ConfidenceGauge({ confidence, accent, size = 56 }: ConfidenceGaugeProps) {
  const clamped = Math.max(0, Math.min(100, confidence));
  const radius = (size - 8) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - clamped / 100);
  const color = ACCENT_HEX[accent];
  return (
    <div className="relative" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="#1a2130" strokeWidth={4} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={4}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 0.6s ease" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-mono text-sm font-semibold tabular leading-none" style={{ color }}>
          {Math.round(clamped)}
        </span>
      </div>
    </div>
  );
}
